import { getDifficultyColor } from '../../utils/difficultyUtils';
import Button from '../ui/Button';

interface LastFeedbackProps {
  lastFeedback: {
    overall_score: number;
    feedback_en: string;
    suggestions_en: string[];
  };
}

export default function LastFeedback({ lastFeedback }: LastFeedbackProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Your Last Feedback</h3>
      <div className="flex items-center mb-4">
        <Button className={`w-24 h-24 flex font-bold flex items-center justify-center mx-auto rounded-full text-white font-bold text-2xl ${getDifficultyColor(lastFeedback.overall_score)}`}>
          {Math.round(lastFeedback.overall_score)}
        </Button>
        <div className="ml-4">
          <p className="text-gray-700">{lastFeedback.feedback_en}</p>
        </div>
      </div>
      <div>
        <h4 className="font-semibold text-gray-700 mb-2">Suggestions for improvement:</h4>
        <ul className="list-disc list-inside text-gray-600 space-y-1">
          {lastFeedback.suggestions_en.map((suggestion, index) => (
            <li key={index}>{suggestion}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}